module.exports = __webpack_public_path__ + "img/bd(4).adf3b1db.webp";